import React from 'react';
import Button from '../components/bootstrap/Button';

const ConnectProfile = () => {
    return (
        <>
            <div className='row'>
                <div className='col-xl-4 col-sm-12'>
                    <div
                        className='platform-card-modal'
                        style={{ borderTop: '5px solid #217BEE' }}>
                        <div className='platform-name-modal'>
                            <img
                                src={require('../assets/facebook.png')}
                                width='30'
                                alt='Facebook'
                            />
                            <p
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '5px',
                                    fontWeight: '600',
                                }}>
                                Facebook
                            </p>
                        </div>
                        <div className='platform-connect-btn mt-2 mb-2'>
                            <Button
                                color='dark'
                                style={{ width: '100%' }}
                                isOutline>
                                Connect
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='col-xl-4 col-sm-12'>
                    <div
                        className='platform-card-modal'
                        style={{ borderTop: '5px solid #E4405F' }}>
                        <div className='platform-name-modal'>
                            <img
                                src={require('../assets/instagram.png')}
                                width='30'
                                alt='Instagram'
                            />
                            <p
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '5px',
                                    fontWeight: '600',
                                }}>
                                Instagram
                            </p>
                        </div>
                        <div className='platform-connect-btn mt-2 mb-2'>
                            <Button
                                color='dark'
                                style={{ width: '100%' }}
                                isOutline>
                                Connect
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='col-xl-4 col-sm-12'>
                    <div
                        className='platform-card-modal'
                        style={{ borderTop: '5px solid #1DA1F2' }}>
                        <div className='platform-name-modal'>
                            <img
                                src={require('../assets/twitter.png')}
                                width='30'
                                alt='Twitter'
                            />
                            <p
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '5px',
                                    fontWeight: '600',
                                }}>
                                Twitter
                            </p>
                        </div>
                        <div className='platform-connect-btn mt-2 mb-2'>
                            <Button
                                color='dark'
                                style={{ width: '100%' }}
                                isOutline>
                                Connect
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='col-xl-4 col-sm-12'>
                    <div
                        className='platform-card-modal mt-4'
                        style={{ borderTop: '5px solid #0A66C2' }}>
                        <div className='platform-name-modal'>
                            <img
                                src={require('../assets/linkedin.png')}
                                width='30'
                                alt='Linkedin'
                            />
                            <p
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '5px',
                                    fontWeight: '600',
                                }}>
                                Linkedin
                            </p>
                        </div>
                        <div className='platform-connect-btn mt-2 mb-2'>
                            <Button
                                color='dark'
                                style={{ width: '100%' }}
                                isOutline>
                                Connect
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='col-xl-4 col-sm-12'>
                    <div
                        className='platform-card-modal mt-4'
                        style={{ borderTop: '5px solid #000000' }}>
                        <div className='platform-name-modal'>
                            <img
                                src={require('../assets/tiktok.png')}
                                width='30'
                                alt='Tiktok'
                            />
                            <p
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '5px',
                                    fontWeight: '600',
                                }}>
                                Tiktok
                            </p>
                        </div>
                        <div className='platform-connect-btn mt-2 mb-2'>
                            <Button
                                color='dark'
                                style={{ width: '100%' }}
                                isOutline>
                                Connect
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='col-xl-4 col-sm-12'>
                    <div
                        className='platform-card-modal mt-4'
                        style={{ borderTop: '5px solid #FF0000' }}>
                        <div className='platform-name-modal'>
                            <img
                                src={require('../assets/youtube.png')}
                                width='30'
                                alt='Youtube'
                            />
                            <p
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '5px',
                                    fontWeight: '600',
                                }}>
                                Youtube
                            </p>
                        </div>
                        <div className='platform-connect-btn mt-2 mb-2'>
                            <Button
                                color='dark'
                                style={{ width: '100%' }}
                                isOutline>
                                Connect
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='col-xl-4 col-sm-12'>
                    <div
                        className='platform-card-modal mt-4'
                        style={{ borderTop: '5px solid #4285F4' }}>
                        <div className='platform-name-modal'>
                            <img
                                src={require('../assets/google-my-business.png')}
                                width='30'
                                alt='Google-Mybusiness'
                            />
                            <p
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '5px',
                                    fontWeight: '600',
                                }}>
                                Google My Business
                            </p>
                        </div>
                        <div className='platform-connect-btn mt-2 mb-2'>
                            <Button
                                color='dark'
                                style={{ width: '100%' }}
                                isOutline>
                                Connect
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='col-xl-4 col-sm-12'>
                    <div
                        className='platform-card-modal mt-4'
                        style={{ borderTop: '5px solid #E60023' }}>
                        <div className='platform-name-modal'>
                            <img
                                src={require('../assets/pinterest.png')}
                                width='30'
                                alt='Pinterest'
                            />
                            <p
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '5px',
                                    fontWeight: '600',
                                }}>
                                Pinterest
                            </p>
                        </div>
                        <div className='platform-connect-btn mt-2 mb-2'>
                            <Button
                                color='dark'
                                style={{ width: '100%' }}
                                isOutline>
                                Connect
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ConnectProfile;
